import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import CustomPopups from './CustomPopups';
import UnsupportedPopup from '../UnsupportedPopup';

const Popups = () => (
  <Tabs defaultActiveKey="custom" className="mb-3" mountOnEnter unmountOnExit>
    <Tab eventKey="custom" title="Custom Popups">
      <CustomPopups />
    </Tab>
    <Tab eventKey="unsupported" title="Unsupported Popups">
      <UnsupportedPopup />
    </Tab>
  </Tabs>
);

export default Popups;
